import { Api } from "../api";

export class UsersApi {
  private api: Api;

  constructor(api: Api) {
    this.api = api;
  }

  async patchUser(form: any) {
    try {
      const response = await this.api.instance.patch("/Users/current", form);
      if (!(response.status === 200)) {
        return { kind: "error" };
      }
      const { data } = response;
      return { kind: "ok", data };
    } catch (e) {
      return { kind: "bad-data" };
    }
  }
}
